<section class="subscription-panel" role="alert">
  <h2>{{ 'mockSubscriptionTitle' | translate }}</h2>
  <p>{{ 'mockSubscriptionBody' | translate }}</p>
  <p *ngIf="keepAnswers">{{ 'mockSubscriptionKept' | translate }}</p>
  <a class="subscribe-button" [href]="shopUrl()" target="_blank" rel="noopener noreferrer">
    {{ 'mockSubscribe' | translate }}
  </a>
</section>
